import React, { useEffect } from 'react'
import { translate } from 'react-multi-lang'
import { Button, Modal } from 'react-bootstrap'
import { connect, useSelector } from 'react-redux'

import { closeModal } from '../../store/actions/ModalAction'
import { postPaymentWalletStart } from '../../store/actions/PostAction'

import LockContent from '../../images_new/icon/lock_content.svg?react'

const UnLockContent = ({ isOpen, toggleModal, data, ...props }) => {
  const modals = useSelector((state) => state.modals.general)
  const handleUnlockContent = () => {
    props.dispatch(
      postPaymentWalletStart({
        post_id: modals.data.post_id,
      })
    )
  }

  const handleCloseModal = () => {
    props.dispatch(closeModal({}))
  }

  useEffect(() => {
    return () => {
      props.dispatch(closeModal({}))
    }
  }, [])

  return (
    <Modal
      show={isOpen}
      onHide={toggleModal}
      className={`unlock verify ${localStorage.getItem('isDark') === 'true' ? 'dark' : 'light'}`}
    >
      <Modal.Body>
        <div className="text-center mt-4 mb-4">
          <LockContent />
          <h2 className="text-center bold">Unlock Content?</h2>
          <p className="text-center">
            Please confirm you want to purchase a post for <span className="red">${modals.data?.amount}</span>
          </p>
        </div>
      </Modal.Body>
      <div className="footer">
        <Button variant="default" onClick={handleCloseModal}>
          Cancel
        </Button>
        <Button
          disabled={props.postPayment.buttonDisable}
          onClick={handleUnlockContent}
          variant="default"
          type="button"
        >
          <div>
            {props.postPayment?.loadingButtonContent ? props.postPayment?.loadingButtonContent : 'Pay & Unlock'}
          </div>
        </Button>
      </div>
    </Modal>
  )
}

function mapDispatchToProps(dispatch) {
  return { dispatch }
}

const mapStateToProps = (state) => ({
  postPayment: state.post.postPaymentWallet,
  data: state.home.unlockContentModal.data,
})

export default connect(mapStateToProps, mapDispatchToProps)(translate(UnLockContent))
